import {NavLink , Link ,  Link as RouterLink} from "react-router-dom";
import { Navbar,Nav } from 'react-bootstrap';
import {Button} from '@mui/material';
import { useUser } from "../../context/UserContext";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Logo from "../Logo/logo";

function NavBar(porps) {

  const {setUser} = useUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('userData');
    navigate('/');
    toast.success('Successfully Logged out!', {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: true,
      closeButton: true,
  });
  };

    return(
        <Navbar expand="lg" variant="dark" className="sticky-top" style={{ backgroundColor: '#5a287d', padding : '12px 24px'}}>
        <Logo isLogoLable = {false} />
        <Navbar.Brand>{porps.heding}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
          <NavLink to="/dashboard" className='nav-link' activeClassName="active">Dashboard</NavLink>
            <NavLink to="/stockoverview" className='nav-link' activeClassName="active">Stock Overview</NavLink>
            <NavLink to="/invest" className='nav-link' activeClassName="active">Invest</NavLink>
            {/* <NavLink to="/dashboard/portfolio" className='nav-link' activeClassName="active">Portfolio</NavLink> */}
            <NavLink to="/esg" className='nav-link' activeClassName="active">ESG Education</NavLink>
            <NavLink to="/transaction-history" className='nav-link' activeClassName="active">Transactions</NavLink>
            <NavLink to="/add-amount" className='nav-link' activeClassName="active">Add Amount</NavLink>
            <NavLink to="/profile" className='nav-link' activeClassName="active">Profile</NavLink>
            {/* <Link to="/logout" className='nav-link' activeClassName='active'>Logout</Link> */}
            <Button onClick={handleLogout} sx={{ color: 'black', backgroundColor: '#ddcceb', '&:hover': { backgroundColor: 'white',  color: 'black',}}}>
              Logout
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )

}


export default NavBar;